<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span> 1-647-898-3518
          <span class="glyphicon glyphicon-envelope"></span> info@lantechautomation.com
          <!-- <span class="glyphicon glyphicon-technical"></span>Expert Support -->
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span> Expert Onsite & Remote Support
          <!-- <span class="glyphicon glyphicon-hand-right"></span> Cantact US -->
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-navs">
        <div class="header-nav-logo">
          <img src="@/assets/img/ltlogo.png">
          <!-- <img src="@/assets/img/logo.jpg"> -->
        </div>
        <p>Lantech Automation</p>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo" style="display: flex;justify-content: center;align-items: center;">

        <img class="center-block" src="@/assets/img/ltlogo.png" alt="logo" style="margin: 0;">
        <h3 style="margin: 0; color: #00729d; font-weight: bold;">Lantech Automation</h3>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "HOME",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "HOME",
          path: "/",
          children: []
        },
        {
          name: "SOLUTIONS",
          path: "/solution",
          children: [
            {
              name: "Smart Home Automation",
              path: "/solution/smart-home"
            },
            {
              name: "Audio/Video System",
              path: "/solution/audio-video"
            },
            {
              name: "Security System",
              path: "/solution/security"
            },
            {
              name: "Network System",
              path: "/solution/network"
            },
          ]
        },
        {
          name: "SERVICES",
          path: "/service",
          children: []
        },
        {
          name: "PARTNERS",
          path: "/partners",
          children: []
        },
        {
          name: "GALLERIES",
          path: "/galleries",
          children: []
        },
        {
          name: "CONTACT US",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  watch: {
      $route: function clearSelectionRow() {
        console.log(this.$route.path);
        if(this.$route.path=="/contactus"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[5].classList.add("active");
        }else if(this.$route.path=="/solution"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[1].classList.add("active");
        }
        else if(this.$route.path=="/solution/security"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[1].classList.add("active");
        }
        else if(this.$route.path=="/solution/network"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[1].classList.add("active");
        }
        else if(this.$route.path=="/solution/audio-video"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[1].classList.add("active");
        }
        else if(this.$route.path=="/solution/smart-home"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[1].classList.add("active");
        }
        else if(this.$route.path=="/galleries"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[4].classList.add("active");
        }
        else if(this.$route.path=="/partners"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[3].classList.add("active");
        }
        else if(this.$route.path=="/service"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[2].classList.add("active");
        }
        else if(this.$route.path=="/home"){
          let li =document.getElementsByClassName("header-nav-wrapper")[0].childNodes
          for(let i=0;i<li.length;i++){
            li[i].classList.remove("active");
          };
          li[0].classList.add("active");
        }
      },
  },
  created() {
  },
  mounted() {
    window.addEventListener('scroll',(e)=>{
      // console.log(document.documentElement.scrollTop,"e",e);
      if(document.documentElement.scrollTop>90){
        document.getElementsByClassName('header-top')[0].style.height = '0px'
        document.getElementsByClassName('container')[0].style.display = 'none'
      }else if(document.documentElement.scrollTop<40){
        document.getElementsByClassName('header-top')[0].style.height = '50px';
        document.getElementsByClassName('container')[0].style.display = 'block'
      }

    })
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
      //add-20231231
      this.menuClass = "glyphicon glyphicon-menu-down";
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  position: sticky;
  top: 0px;
  background: #ffffff;
  transition: all ease 0.6s;
  z-index: 100000;
}
#header .header-top {
  height: 50px;
  /* color: #c3f3ef; */
  /* color:#fff; */
  color:white;
  font-size: 20px;
  font-weight: bold;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 50px;
  background: #4bc0dd;
  /* background: #51abb6; */
  /* background: #2dabbb; */
  /* background: #f1f1f1; */
  transition: all 0.4s;
}
/* #header .header-top .container{
} */
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  display: flex;
  justify-content: space-between;
  height: 100px;
}
/* 导航栏logo */
#header .header-navs{
  width: 400px;
  height: 100%;
  display: flex;
  float: left;
  align-items: center;
}

#header .header-navs p{
  font-size: 30px;
  color: #00729d;
  font-weight: bold;
}

#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  position: relative;
  overflow: hidden;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
  height: 75%;
  position: absolute;
  top: 0%;
  left: 0%;
  bottom: 0;
  right: 0;
  margin:auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  /* width: 168px; */
  width: 236px;
  top: 80%;
  left: 0;
  z-index: 999999;
  /* box-shadow: 0 0 3px 1px #ccc; */
  /* box-shadow: 0 0 3px 1px #00729d; */
  /* background: #fff; */
  background: #f0a032;
  border-radius: 10px;
  overflow: hidden;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  /* color: white; */
  border-bottom: 1px solid #ccc;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a{
  display: block;
  font-weight: bold;
  color: white;
  width: 100%;
  height: 100%;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
  /* background-color: #cd7e0e; */
  /* color: #cd7e0e; */ /* font color */
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;

}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  /* background: #ccc; */
  background: #cd7e0e;

}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 60px;
    height: 45px;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    font-weight: bold;
    line-height: 50px;
    /* background: #474747; */
    background: #cd7e0e;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: rgb(160, 108, 29);
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue